import { gql } from '@apollo/client';

export const MUTATION_GENERATE_COMPOSITE_ANALYSIS_PDF = gql`
  mutation GenerateCompositeAnalysisPDF(
    $municipalityCode: String!
    $comparativeMunicipalitycodes: [String!]
    $language: String!
  ) {
    generateCompositeAnalysisPDF(
      municipality_code: $municipalityCode
      comparative_municipalitycodes: $comparativeMunicipalitycodes
      language: $language
    ) {
      url
    }
  }
`;
